import type { PersonalHealthProfileState } from './types';

export const initialState: PersonalHealthProfileState = {
  pendingProfile: null,
};
